import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Heading, Button, Cross } from '@pretamanger/component-library'

export const ModalContent = styled('div')`
  ${tw`w-full`}
`

export const ModalText = styled('div')`
  ${tw`mx-auto max-w-[610px]`}
`

export const ModalTitle = styled(Heading)`
  ${tw`font-bold text-grey-700 mb-4 text-center text-[32px] leading-10 md:text-[40px]`}
`

export const ModalDescription = styled('p')`
  ${tw`font-normal text-grey-700 mb-4 text-center leading-6`}
`

export const FilterVegan = styled('div')<{ isNotHidden?: boolean }>`
  ${({ isNotHidden }) =>
    isNotHidden ? tw`hidden lg:block mb-6` : tw`md:hidden mt-4 mb-12`}
`

export const LabelVeganOption = styled('p')`
  ${tw`font-bold text-grey-700 mb-4 text-left text-lg leading-7 mb-4`}
`

export const ButtonWrapper = styled('div')`
  ${tw`flex justify-between mt-10 py-2 border-t-[1px] border-[#D9D9D9] md:border-t-0`}
`

export const ButtonOption = styled(Button)`
  ${tw`h-12 w-full`}
`

export const AllergensWrapper = styled('div')`
  ${tw`hidden md:grid md:grid-cols-3 md:gap-4 md:mt-8 md:mb-12`}
`

export const ModalCloseButton = styled(Button)`
  ${tw`p-2 flex float-left bg-white hover:bg-transparent focus:bg-transparent absolute`}
  top: 5px;
  left: 5px;

  span {
    ${tw`ml-1`}
  }
`

export const ModalCross = styled(Cross)`
  ${tw`inline px-1 cursor-pointer`}
`
